// API文档相关API
import request from '@/api'

// API文档 发起调用
export async function apiExplorer(data) {
  return request({
    url: '/dc-api/api/v1/explorer/call',
    method: 'post',
    data
  })
}

// API分组查询所有
export async function apiGroupFind(data) {
  return request({
    url: '/dc-api/api/v1/group/find',
    method: 'post',
    data
  })
}

// 查询单个api id查询
export async function apiFindByGroupId(data) {
  return request({
    url: '/dc-api/api/v1/api/find',
    method: 'post',
    data
  })
}

// 得到产品文档内容
export async function getDocContent(data) {
  return request({
    url: '/dc-api/api/v1/project_doc/getContent',
    method: 'post',
    data
  })
}

// 得到左侧产品菜单
export async function docMenu(data) {
  return request({
    url: '/dc-api/api/v1/project_doc/getMenu',
    method: 'post',
    data
  })
}

// apiDoc的tree菜单
export async function apiDocTreeMenu(data) {
  return request({
    url: '/dc-api/api/v1/group/tree',
    method: 'post',
    data
  })
}

// 查询单个api内容详情
export async function apiDetailFindById(data) {
  return request({
    url: `/dc-api/api/v1/api/${data}`,
    method: 'get',
    data
  })
}

// 获取上传key
export async function getUploadKey(data) {
  return request({
    url: `/capi/web-service/uaes/commons/getCosTmp/${data}`,
    method: 'get',
    data
  })
}
export async function download(moduleKey) {
  return request({
    url: `/capi/web-service/uaes/commons/download`,
    method: 'get',
    params: { objectKey: moduleKey }
  })
}
export async function getDetailList(data) {
  return request({
    url: `/capi/scene-service/scene/as/getDetailList`,
    method: 'get',
    data
  })
}
